import { TemplateType } from '@/types/templateRules';

export interface TemplateConfig {
  id: TemplateType;
  name: string;
  icon: string;
  description: string | null;
}

// This matches your database schema and can be used as a fallback
// when the database is not available or during development
export const DEFAULT_TEMPLATE_CONFIGS: TemplateConfig[] = [
  {
    id: 'announcement',
    name: 'Announcement',
    icon: 'bell',
    description: null
  },
  {
    id: 'blog',
    name: 'Blog',
    icon: 'file-text',
    description: null
  },
  {
    id: 'case',
    name: 'Case',
    icon: 'briefcase',
    description: null
  },
  {
    id: 'comparison',
    name: 'Comparison',
    icon: 'sliders-horizontal',
    description: null
  },
  {
    id: 'faq',
    name: 'FAQ',
    icon: 'help-circle',
    description: null
  },
  {
    id: 'feature_page',
    name: 'Feature Page',
    icon: 'layers',
    description: null
  },
  {
    id: 'guide',
    name: 'Guide',
    icon: 'book-open',
    description: null
  },
  {
    id: 'insight',
    name: 'Insight',
    icon: 'lightbulb',
    description: null
  },
  {
    id: 'landing',
    name: 'Landing',
    icon: 'layout',
    description: null
  },
  {
    id: 'landing_page',
    name: 'Landing Page',
    icon: 'mouse-pointer-click',
    description: null
  },
  {
    id: 'listicle',
    name: 'Listicle',
    icon: 'list',
    description: null
  },
  {
    id: 'press_release',
    name: 'Press Release',
    icon: 'megaphone',
    description: null
  },
  {
    id: 'research',
    name: 'Research',
    icon: 'chart',
    description: 'deep research the topic'
  }
];

// Helper function to get template config by ID
export const getTemplateConfig = (id: TemplateType): TemplateConfig | undefined => {
  return DEFAULT_TEMPLATE_CONFIGS.find(template => template.id === id);
};

// Helper function to get all template configs
export const getAllTemplateConfigs = (): TemplateConfig[] => {
  return DEFAULT_TEMPLATE_CONFIGS;
}; 